export enum AutorisationType {
  SignUp = 'sign-in',
  Login = 'login',
  Default = '',
  Guest = 'guest',
  RestorePassword = 'restore-password',
}
